import { Container } from 'inversify';
import { MessagingInterface, MessagingService } from './messaging.service';

export const messagingContainer = new Container();
messagingContainer.bind<MessagingInterface>(MessagingService).toSelf().inSingletonScope();
